export default __webpack_public_path__ + "static/screenshot_beach-a3e98fffe499e978308adb8b6f41e99c.png";